import { render, staticRenderFns } from "./product-overview-card.vue?vue&type=template&id=e8e502c0&scoped=true"
import script from "./product-overview-card.vue?vue&type=script&lang=js"
export * from "./product-overview-card.vue?vue&type=script&lang=js"
import style0 from "./product-overview-card.vue?vue&type=style&index=0&id=e8e502c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e502c0",
  null
  
)

export default component.exports